import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { AuthService } from '@ubie/core';

@Directive({
  selector: '[hasClaim]',
  standalone: false,
})
export class HasClaimDirective {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authService = inject(AuthService);
  private hasView = false;

  @Input() set hasClaim(claimType: string | string[]) {
    const permissionGranted = this.authService.hasClaim(claimType);

    if (permissionGranted && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);

      this.hasView = true;
    } else if (!permissionGranted && this.hasView) {
      this.viewContainer.clear();

      this.hasView = false;
    }
  }
}

@Directive({
  selector: '[hasClaim]',
  standalone: true,
})
export class HasClaimStandaloneDirective {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authService = inject(AuthService);
  private hasView = false;

  @Input() set hasClaim(claimType: string | string[]) {
    const permissionGranted = this.authService.hasClaim(claimType);

    if (permissionGranted && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);

      this.hasView = true;
    } else if (!permissionGranted && this.hasView) {
      this.viewContainer.clear();

      this.hasView = false;
    }
  }
}
